const INITIAL_STATE = {
  isAuthReady: false,
};

const authReducer = (state = INITIAL_STATE, action) => {
  switch (action.type) {
    case 'AUTH_IS_READY':
      return { ...state, isAuthReady: true };
    default:
      return state;
  }
};

export default authReducer;

